import React from "react";
import loading from "../35.svg";
const Loading = () => {
  return (
    <div className="loading">
      <img src={loading} alt="" />
    </div>
  );
};

export default Loading;
